<div
    class="pl-grid-card"
    [routerLink]="productLink"
    [attr.aria-label]="product.productName"
    role="link"
    tabindex="0"
>
    <div class="pl-grid-card__media">
        <ng-container *ngIf="hasImage; else noImage">
            <img
                class="pl-grid-card__image"
                [src]="product.productAsset?.preview | productImageSrc : 'thumb' : product.productAsset?.id"
                vsfFallbackSrc
                [alt]="product.productName"
            />
        </ng-container>
        <ng-template #noImage>
            <div class="pl-grid-card__empty">
                <img src="assets/icons/venduro-favicon.svg" alt="" />
                <span>No image available</span>
            </div>
        </ng-template>
        <span
            *ngIf="isHotOffer"
            class="pl-grid-card__hot"
            title="Hot offer"
            aria-label="Hot offer"
        >
            <img src="assets/icons/hot-offer-flame.svg" alt="" />
        </span>
    </div>

    <div class="pl-grid-card__ean" *ngIf="gtin">
        <span>{{ gtin }}</span>
        <button
            type="button"
            class="pl-grid-card__ean-copy"
            title="Copy EAN"
            aria-label="Copy EAN"
            (click)="copyGtin($event)"
        >
            <img src="assets/icons/copy-icon.svg" alt="" />
        </button>
    </div>

    <div class="pl-grid-card__brand" *ngIf="brand">{{ brand }}</div>
    <div class="pl-grid-card__name">{{ product.productName | titlecase }}</div>

    <div class="pl-grid-card__price-row" *ngIf="isLoggedIn; else guestPrice">
        <span class="pl-grid-card__offers">{{ offerCount }} offers from</span>
        <div class="pl-grid-card__price" *ngIf="cheapestPrice != null">
            {{ cheapestPrice | formatPrice }}
        </div>
        <span
            *ngIf="marginPercent != null"
            class="pl-grid-card__margin"
            (click)="$event.preventDefault(); $event.stopPropagation()"
        >
            {{ marginPercent }}%
            <vsf-retail-price-hint
                [productId]="product.productId"
            ></vsf-retail-price-hint>
        </span>
    </div>
    <ng-template #guestPrice>
        <div class="pl-grid-card__guest">Login to see wholesale prices</div>
    </ng-template>
</div>
